import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Send } from "lucide-react";
import { COURSES } from "@/data/courses";
import { SITE, telLink, mailLink, waLink } from "@/data/site";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-brand-navy text-white relative overflow-hidden"
        >
            <div className="container-x pt-20 pb-10 grid lg:grid-cols-12 gap-12">
                <div className="lg:col-span-5">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="w-12 h-12 bg-brand-crimson grid place-items-center font-heading font-black text-2xl">
                            D
                        </div>
                        <div>
                            <div className="font-heading font-extrabold text-2xl tracking-tight">
                                Dacron Classes
                            </div>
                            <div className="text-[11px] tracking-[0.22em] uppercase text-brand-gold">
                                Pathankot · Punjab
                            </div>
                        </div>
                    </div>
                    <p className="text-white/70 leading-relaxed max-w-md mb-6">
                        Pathankot's most trusted coaching institute for Sainik School,
                        NDA, RIMC, RMS, NEET, JEE, foundation and tuition (Class 6-12).
                        100+ selections, ex-officer mentors, NTA-pattern mocks.
                    </p>
                    <div className="space-y-3 text-sm">
                        <a
                            href={telLink}
                            data-testid="footer-phone"
                            className="flex items-center gap-3 hover:text-brand-gold transition-colors"
                        >
                            <Phone className="w-4 h-4 text-brand-gold" /> {SITE.phone}
                        </a>
                        <a
                            href={mailLink}
                            data-testid="footer-email"
                            className="flex items-center gap-3 hover:text-brand-gold transition-colors"
                        >
                            <Mail className="w-4 h-4 text-brand-gold" /> {SITE.email}
                        </a>
                        <div className="flex items-start gap-3">
                            <MapPin className="w-4 h-4 text-brand-gold mt-1 shrink-0" />
                            <span className="text-white/80">{SITE.address}</span>
                        </div>
                    </div>
                </div>

                <div className="lg:col-span-3">
                    <div className="overline text-brand-gold mb-5">Top Courses</div>
                    <ul className="space-y-2.5 text-sm">
                        {COURSES.slice(0, 8).map((c) => (
                            <li key={c.slug}>
                                <Link
                                    to={`/${c.slug}`}
                                    data-testid={`footer-link-${c.slug}`}
                                    className="text-white/75 hover:text-white hover:underline underline-offset-4"
                                >
                                    {c.short} in Pathankot
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="lg:col-span-4">
                    <div className="overline text-brand-gold mb-5">Quick Links</div>
                    <ul className="space-y-2.5 text-sm">
                        <li>
                            <Link to="/" className="text-white/75 hover:text-white">
                                Home
                            </Link>
                        </li>
                        <li>
                            <a href="#why-us" className="text-white/75 hover:text-white">
                                Why Choose Dacron
                            </a>
                        </li>
                        <li>
                            <a href="#testimonials" className="text-white/75 hover:text-white">
                                Student Results & Testimonials
                            </a>
                        </li>
                        <li>
                            <a href="#faq" className="text-white/75 hover:text-white">
                                FAQs
                            </a>
                        </li>
                        <li>
                            <a href="#contact" className="text-white/75 hover:text-white">
                                Contact & Map
                            </a>
                        </li>
                        <li>
                            <a
                                href={waLink()}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-white/75 hover:text-white"
                            >
                                WhatsApp Enquiry
                            </a>
                        </li>
                    </ul>

                    <a
                        href="#enquiry"
                        data-testid="footer-cta-enquire"
                        className="mt-8 inline-flex items-center gap-2 bg-brand-crimson hover:bg-brand-crimsonHover px-5 py-3 font-heading font-semibold transition-colors"
                    >
                        Book Free Demo Class <Send className="w-4 h-4" />
                    </a>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="container-x py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/55">
                    <div>
                        © {new Date().getFullYear()} Dacron Classes, Pathankot. All
                        rights reserved.
                    </div>
                    <div className="tracking-[0.2em] uppercase">
                        Best Coaching Institute in Pathankot
                    </div>
                </div>
            </div>
        </footer>
    );
}
